import NonPcnSuggest from './NonPcnSuggest';
import { PcnResultTypes } from '@src/utils/enums';
import { commonQuestionData, QuestionDataById } from '@components/dynamic-form/types';
import { getParentObject } from './nonPcnData.types';

const navigationQuestionsById: QuestionDataById = {
  133: {
    sectionId: 36,
    helpInfo:
      "General Condition 1. Any safety lights and signals prescribed by the U.S. Coast Guard, through regulations or otherwise, must be installed and maintained at the permittee's expense on authorized facilities in navigable waters of the United States. The permittee understands and agrees that, if future operations by the United States require the removal, relocation, or other alteration, of the structure or work herein authorized, or if, in the opinion of the Secretary of the Army or his or her authorized representative, said structure or work shall cause unreasonable obstruction to the free navigation of the navigable waters, the permittee will be required, upon due notice from USACE, to remove, relocate, or alter the structural work or obstructions caused thereby, without expense to the United States. No claim shall be made against the United States on account of any such removal or alteration.",
    question: 'Will the activity cause more than minimal adverse effect on navigation?',
    parentQuestions: [
      getParentObject(11, 5, '=', 'YES'),
      getParentObject(12, 5, '=', 'YES'),
      getParentObject(18.1, 5, '=', 'NO'),
      getParentObject(19.1, 5, '=', 'NO'),
      getParentObject(22, 5, '=', 'NO'),
      getParentObject(23, 5, '=', 'YES'),
      getParentObject(33, 5, '=', 'NO'),
      getParentObject(34, 5, '=', 'YES'),
      getParentObject(35, 5, '=', 'YES'),
      getParentObject(37, 5, '=', 'YES'),
      getParentObject(52, 5, 'exists', ''),
      getParentObject(62, 5, 'exists', ''),
      getParentObject(67, 5, '=', 'NO'),
      getParentObject(69, 5, '=', 'NO'),
      getParentObject(70, 5, '=', 'YES'),
      getParentObject(73, 5, '=', 'NO'),
      getParentObject(74.2, 5, '=', 'YES'),
      getParentObject(75, 5, '=', 'YES'),
      getParentObject(75.1, 5, '=', 'YES'),
      getParentObject(75.2, 5, '=', 'YES'),
      getParentObject(78, 5, '=', 'NO'),
      getParentObject(80, 5, '=', 'NO'),
      getParentObject(81, 5, '=', 'YES'),
      getParentObject(82.2, 5, '=', 'YES'),
      getParentObject(83.1, 5, '=', 'NO'),
      getParentObject(86, 5, '=', 'NO'),
      getParentObject(92, 5, '=', 'NO'),
      getParentObject(93.1, 5, '=', 'YES'),
      getParentObject(99.1, 5, '=', 'YES'),
      getParentObject(100.2, 5, '=', 'NO'),
      getParentObject(102.2, 5, '=', 'NO'),
      getParentObject(107, 5, '=', 'NO'),
      getParentObject(109, 5, '=', 'NO'),
      getParentObject(120, 5, 'exists', ''),
      getParentObject(131, 5, 'exists', ''),
      getParentObject(132.4, 5, '=', 'NO'),
    ],
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const aquaticLifeMovementQuestionsById: QuestionDataById = {
  134: {
    sectionId: 37,
    helpInfo:
      'General Condition 2. If a bottomless culvert cannot be used, then the crossing should be designed and constructed to minimize adverse effects to aquatic life movements.',
    question:
      "Will the activity substantially disrupt the necessary life cycle movements of those species of aquatic life indigenous to the waterbody, including those species that normally migrate through the area, unless the activity's primary purpose is to impound water?",
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(133, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  135: {
    sectionId: 37,
    helpInfo:
      'General Condition 2. If a bottomless culvert cannot be used, then the crossing should be designed and constructed to minimize adverse effects to aquatic life movements.',
    question:
      'If there will be permanent or temporary crossings of waterbodies associated with the activity, will they be suitably culverted, bridged, or otherwise designed and constructed to maintain low flows to sustain the movement of those aquatic species?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(134, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const spawningAreaQuestionsById: QuestionDataById = {
  136: {
    sectionId: 38,
    helpInfo:
      'General Condition 3. Activities in spawning areas during spawning seasons must be avoided to the maximum extent practicable.',
    question: 'Will the activity result in physical destruction of an important spawning area?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(135, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const migratoryBirdQuestionsById: QuestionDataById = {
  137: {
    sectionId: 39,
    helpInfo: 'General Condition 4.',
    question:
      'Will the activity avoid waters of the United States that serve as breeding areas for migratory birds to the maximum extent practicable?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(136, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const shellfishBedsQuestionsById: QuestionDataById = {
  138: {
    sectionId: 40,
    helpInfo: 'General Condition 5.',
    question: 'Will the activity take place in areas of concentrated shellfish populations?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(137, 7, '=', 'YES')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  139: {
    sectionId: 40,
    helpInfo: 'General Condition 5.',
    question:
      'If the activity will take place in areas of concentrated shellfish populations, is it directly related to a shellfish harvesting activity authorized by NWPs 4 and 48, or is a shellfish seeding or habitat restoration activity authorized by NWP 27?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(138, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const suitableMaterialQuestionsById: QuestionDataById = {
  140: {
    sectionId: 41,
    helpInfo:
      'General Condition 6. Material used for construction or discharged must be free from toxic pollutants in toxic amounts (see Section 307 of the Clean Water Act).',
    question: 'Will the activity use unsuitable material (e.g., trash, debris, car bodies, asphalt, etc.)?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(138, 7, '=', 'NO'), getParentObject(139, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const waterSupplyQuestionsById: QuestionDataById = {
  141: {
    sectionId: 42,
    helpInfo: 'General Condition 7.',
    question: 'Will the activity occur in proximity of a public water supply intake?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(140, 5, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.ContactDistrict} />,
      },
    ],
    ...commonQuestionData,
  },
  142: {
    sectionId: 42,
    helpInfo: 'General Condition 7.',
    question:
      'If the activity will occur in proximity of a public water supply intake, is the activity for the repair or improvement of public water supply intake structures or adjacent bank stabilization?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(141, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const adverseImpoundmentQuestionsById: QuestionDataById = {
  143: {
    sectionId: 43,
    helpInfo: 'General Condition 8.',
    question:
      'If the activity is associated with an impoundment of water, will adverse effects to the aquatic system be minimized to the maximum extent practicable?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(141, 7, '=', 'NO'), getParentObject(142, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const waterFlowManagementQuestionsById: QuestionDataById = {
  144: {
    sectionId: 44,
    helpInfo: 'General Condition 9. The activity must be constructed to withstand expected high flows.',
    question:
      'Will the preconstruction course, condition, capacity, and location of open waters be maintained to the maximum extent practicable for each activity, including stream channelization, storm water management activities, and temporary and permanent road crossings?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(143, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  145: {
    sectionId: 44,
    helpInfo: 'General Condition 9. The activity must be constructed to withstand expected high flows.',
    question:
      'If the activity will restrict or impede the passage of normal or high flows, is the primary purpose of the activity to impound water or manage high flows?',
    questionTypeId: 7,
    parentQuestions: [getParentObject(144, 5, '=', 'YES')],
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  146: {
    sectionId: 44,
    helpInfo: 'General Condition 9. The activity must be constructed to withstand expected high flows. ',
    question:
      'If the activity will alter the preconstruction course, condition, capacity, and location of open waters, is it for the benefit of the aquatic environment (e.g., stream restoration or relocation activities)?',
    questionTypeId: 7,
    parentQuestions: [getParentObject(145, 7, '!=', 'NO')],
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const floodplainQuestionsById: QuestionDataById = {
  147: {
    sectionId: 45,
    helpInfo: 'General Condition 10.',
    question:
      'Will the activity comply with applicable FEMA approved state or local floodplain management requirements?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(146, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const equipmentQuestionsById: QuestionDataById = {
  148: {
    sectionId: 46,
    helpInfo: 'General Condition 11.',
    question:
      'If the activity requires the use of heavy equipment working in wetlands or mudflats, will mats or other measures be taken to minimize soil disturbance?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(147, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const soilErosionQuestionsById: QuestionDataById = {
  149: {
    sectionId: 47,
    helpInfo:
      'General Condition 12. Permittees are encouraged to perform work within waters of the United States during periods of low-flow or no-flow, or during low tides.',
    question:
      'Will the activity use appropriate soil erosion and sediment controls and will the controls be maintained in effective operating condition during construction?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(148, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  150: {
    sectionId: 47,
    helpInfo: 'General Condition 12.',
    question:
      'Will all exposed soil and other fills, as well as any work below the ordinary high water mark or high tide line, be permanently stabilized at the earliest practicable date?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(149, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const removalOfTempStructuresFillsQuestionsById: QuestionDataById = {
  151: {
    sectionId: 48,
    helpInfo:
      'General Condition 13. Temporary fills must be removed in their entirety and the affected areas returned to preconstruction elevations. The affected areas must be revegetated, as appropriate.',
    question:
      'If the activity involves temporary structures, will they be removed, to the maximum extent practicable, after their use has been discontinued?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(150, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const properMaintenanceQuestionsById: QuestionDataById = {
  152: {
    sectionId: 49,
    helpInfo: 'General Condition 14.',
    question:
      'Will the authorized structure or fill be properly maintained, including maintenance to ensure public safety and compliance with applicable NWP general conditions?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(151, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const singleCompleteProjectQuestionsById: QuestionDataById = {
  153: {
    sectionId: 50,
    helpInfo: 'General Condition 15.',
    question:
      'Is the project a linear project, constructed to transport people, goods, or services from a point of origin to a terminal point?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(152, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  154: {
    sectionId: 50,
    helpInfo:
      'General Condition 15. Single and complete linear project: A linear project is a project constructed for the purpose of getting people, goods, or services from a point of origin to a terminal point, which often involves multiple crossings of one or more waterbodies at separate and distant locations. The term “single and complete project” is defined as that portion of the total linear project proposed or accomplished by one owner/developer or partnership or other association of owners/developers that includes all crossings of a single water of the United States (i.e., a single waterbody) at a specific location. For linear projects crossing a single or multiple waterbodies several times at separate and distant locations, each crossing is considered a single and complete project for purposes of NWP authorization. However, individual channels in a braided stream or river, or individual arms of a large, irregularly shaped wetland or lake, etc., are not separate waterbodies, and crossings of such features cannot be considered separately.',
    question:
      'Does the linear project include all crossings of a single waterbody at a specific location? Individual channels in braided streams or separate arms of wetlands or lakes are considered part of the same single waterbody.',
    questionTypeId: 5,
    parentQuestions: [getParentObject(153, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  155: {
    sectionId: 50,
    helpInfo:
      'General Condition 15. Single and complete non-linear project: For non-linear projects, the term “single and complete project” is defined at 33 CFR 330.2(i) as the total project proposed or accomplished by one owner/developer or partnership or other association of owners/developers. A single and complete non-linear project must have independent utility (see definition of “independent utility”). Single and complete non-linear projects may not be “piecemealed” to avoid the limits in an NWP authorization.',
    question:
      'Does this application represent the entire non-linear project under the control of a single owner/developer or coordinated group?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(153, 5, '=', 'NO'), getParentObject(154, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  156: {
    sectionId: 50,
    helpInfo:
      'General Condition 15. Independent utility: A test to determine what constitutes a single and complete non-linear project in the USACE Regulatory Program. A project is considered to have independent utility if it would be constructed absent the construction of other projects in the project area. Portions of a multi-phase project that depend upon other phases of the project do not have independent utility. Phases of a project that would be constructed even if the other phases were not built can be considered as separate single and complete projects with independent utility.',
    question: 'Does the project have independent utility (would it be constructed absent other projects in the area)?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(155, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  157: {
    sectionId: 50,
    helpInfo:
      'General Condition 15. The same NWP cannot be used more than once for the same single and complete project. Impacts associated with a phased project that does not have independent utility are considered cumulatively.',
    question:
      'If the activity is part of a phased project that does not have independent utility, do the cumulative impacts of the project fall under the thresholds of the applicable NWP?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(156, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const tribalRightsQuestionsById: QuestionDataById = {
  158: {
    sectionId: 52,
    helpInfo: 'General Condition 17.',
    question:
      'Will the activity or its operation impair reserved tribal rights, including, but not limited to, reserved water rights and treaty fishing and hunting rights?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(157, 7, '!=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const migratoryBirdGoldEagleQuestionsById: QuestionDataById = {
  159: {
    sectionId: 54,
    helpInfo:
      'General Condition 19. The permittee is responsible for contacting the appropriate local office of the U.S. Fish and Wildlife Service to determine what measures, if any, are necessary or appropriate to reduce adverse effects to migratory birds or eagles, including whether "incidental take" permits are necessary and available under the Migratory Bird Treaty Act or Bald and Golden Eagle Protection Act for a particular activity. ',
    question:
      'Will the activity comply with the Migratory Bird Treaty Act and the Bald and Golden Eagle Protection Act?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(158, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const remainsArtifactsDiscoveryQuestionsById: QuestionDataById = {
  160: {
    sectionId: 56,
    helpInfo: 'General Condition 21.',
    question:
      'Does the permittee acknowledge that if they discover any previously unknown historic, cultural or archeological remains and artifacts while accomplishing the activity authorized by an NWP, they must immediately notify the district engineer of what they have found, and to the maximum extent practicable, avoid construction activities that may affect the remains and artifacts until the required coordination has been completed?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(159, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const critResourceWatersQuestionsById: QuestionDataById = {
  161: {
    sectionId: 57,
    helpInfo:
      'General Condition 22. Critical resource waters include, NOAA managed marine sanctuaries and marine monuments, and National Estuarine Research Reserves. The district engineer may designate, after notice and opportunity for public comment, additional waters officially designated by a state as having particular environmental or ecological significance, such as outstanding national resource waters or state natural heritage sites. The district engineer may also designate additional critical resource waters after notice and opportunity for public comment.',
    question: 'Will the activity take place in a critical resource water?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
      },
    ],
    parentQuestions: [getParentObject(160, 5, '=', 'YES')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  162: {
    sectionId: 57,
    helpInfo:
      'General Condition 22. Discharges of dredged or fill material into waters of the United States are not authorized by NWPs 7, 12, 14, 16, 17, 21, 29, 31, 35, 39, 40, 42, 43, 44, 49, 50, 51, 52, 57 and 58 for any activity within, or directly affecting, critical resource waters, including wetlands adjacent to such waters.',
    question:
      'Will the activity be covered by NWPs 7, 12, 14, 16, 17, 21, 29, 31, 35, 39, 40, 42, 43, 44, 49, 50, 51, 52, 57 and/or 58?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(161, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  163: {
    sectionId: 57,
    helpInfo: 'General Condition 22.',
    question:
      'Will the activity be covered by  NWPs 3, 8, 10, 13, 15, 18, 19, 22, 23, 25, 27, 28, 30, 33, 34, 36, 37, 38, and/or 54?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(162, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const mitigationQuestionsById: QuestionDataById = {
  164: {
    sectionId: 58,
    helpInfo: 'General Condition 23.',
    question:
      'Will the activity be designed and constructed to avoid and minimize adverse effects, both temporary and permanent, to waters of the United States to the maximum extent practicable at the project site?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(161, 7, '=', 'NO'), getParentObject(163, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PcnRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};
const impoundmentStructureSafetyQuestionsById: QuestionDataById = {
  165: {
    sectionId: 59,
    helpInfo:
      'General Condition 24. To ensure that all impoundment structures are safely designed, the district engineer may require non-Federal applicants to demonstrate that the structures comply with established state or federal, dam safety criteria or have been designed by qualified persons. The district engineer may also require documentation that the design has been independently reviewed by similarly qualified persons, and appropriate modifications made to ensure safety',
    question:
      'If the activity involves the construction of an impoundment structure, will it be safely designed and comply with all established state or federal, dam safety criteria, and/or has it been designed by qualified persons?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(164, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
};
const waterQualityQuestionsById: QuestionDataById = {
  166: {
    sectionId: 60,
    helpInfo:
      'Additional information regarding WQC Certification can be found by visiting your [local Regulatory Webpage](https://regulatory.ops.usace.army.mil/offices/).',
    question:
      'Has a blanket 401 Water Quality Certification (WQC) been issued by the Certifying Authority for the applicable NWP?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(165, 7, '!=', 'NO')],
    ...commonQuestionData,
  },
  166.1: {
    sectionId: 60,
    question: `Your project requires an individual 401 water quality certification (WQC) from the local Certifying Authority.  Please contact the appropriate Certifying Authority regarding this requirement.  
      After obtaining a 401 WQC you must submit a copy of the 401 WQC to USACE.  The proposed work cannot be authorized by NWP if the Certifying Authority denies the 401 WQC. Upon receiving the 401 WQC, USACE will notify the U.S Environmental Protection Agency (EPA).  The EPA may take up to 30 days to review your project and to determine if the project may affect water quality in a neighboring jurisdiction.  The 401 WQC process will be complete if EPA determines the project may not affect water quality in a neighboring jurisdiction or if EPA does not act within the 30 days.  The EPA will notify you, USACE, and the neighboring jurisdiction if EPA determines the project may affect water quality in a neighboring jurisdiction.`,
    questionTypeId: 99,
    parentQuestions: [getParentObject(166, 7, '=', 'NO')],
    endConditions: [],
    alertType: 'warning',
    ...commonQuestionData,
  },
  167: {
    sectionId: 60,
    helpInfo: 'General Condition 26.',
    question: 'Does the project comply with the conditions of the 401 WQC?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(166, 7, '=', 'YES')],
    ...commonQuestionData,
  },
  167.1: {
    sectionId: 60,
    question: `Your project requires an individual 401 water quality certification (WQC) from the local Certifying Authority.  Please contact the appropriate Certifying Authority regarding this requirement.  
      After obtaining a 401 WQC you must submit a copy of the 401 WQC to USACE.  The proposed work cannot be authorized by NWP if the Certifying Authority denies the 401 WQC. Upon receiving the 401 WQC, USACE will notify the U.S Environmental Protection Agency (EPA).  The EPA may take up to 30 days to review your project and to determine if the project may affect water quality in a neighboring jurisdiction.  The 401 WQC process will be complete if EPA determines the project may not affect water quality in a neighboring jurisdiction or if EPA does not act within the 30 days.  The EPA will notify you, USACE, and the neighboring jurisdiction if EPA determines the project may affect water quality in a neighboring jurisdiction.`,
    questionTypeId: 99,
    parentQuestions: [getParentObject(167, 5, '=', 'NO')],
    endConditions: [],
    alertType: 'warning',
    ...commonQuestionData,
  },
  168: {
    sectionId: 60,
    question:
      'Is the project located within a Coastal Zone Management Area? See https://coast.noaa.gov/czm/mystate/ for a list of Coastal Zones in your State.',
    questionTypeId: 5,
    parentQuestions: [getParentObject(166, 7, '!=', 'YES'), getParentObject(167, 5, 'exists', '')],
    ...commonQuestionData,
  },
  169: {
    sectionId: 60,
    question:
      'Are you or are you acting on behalf of a Federal Applicant, or proposing work on Tribal Trust lands (33 CFR 330.4(d)(8); 33 CFR 325.2(b)(2)(i); 33 CFR 325.2(b)(2)(iii)))?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(168, 5, '=', 'YES')],
    ...commonQuestionData,
  },
  169.1: {
    sectionId: 60,
    question: `Under the Coastal Zone Management Act (CZMA), the Corps has obtained general consistency concurrence for some NWP activities; however, the USACE general consistency concurrence does not apply to federal agency activities. Your project requires an individual CZMA consistency concurrence from the State administering agency or a presumption of concurrence must occur. The FEDERAL AGENCY is responsible for complying with the CZMA's directive for ensuring that its federal agency activities are undertaken in a manner which is consistent, to the maximum extent practicable, with approved CZMA Programs.  Please contact the State administering agency regarding this requirement. Additional information can be found on the National Oceanic and Atmospheric Administration Office of Coastal Management website: https://coast.noaa.gov/czm/mystate/.`,
    questionTypeId: 99,
    parentQuestions: [getParentObject(169, 5, '=', 'YES')],
    endConditions: [],
    alertType: 'warning',
    ...commonQuestionData,
  },
};
const coastalZoneManagementQuestionsById: QuestionDataById = {
  170: {
    sectionId: 61,
    helpInfo:
      'Additional information regarding CZMA Consistency can be found by visiting your [local Regulatory Webpage](https://regulatory.ops.usace.army.mil/offices/).',
    question:
      'Has a blanket Coastal Zone Management Act (CZMA) Federal Consistency Concurrence been issued by the State administering agency for the applicable NWP?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
      },
      {
        listId: 1,
        valueDesc: 'No',
      },
      {
        listId: 1,
        valueDesc: 'Not Applicable',
      },
    ],
    parentQuestions: [getParentObject(169, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'Not Applicable',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  170.1: {
    sectionId: 61,
    question: `Your project requires an individual Coastal Zone Management Act (CZMA) consistency concurrence from the State administering agency  or a presumption of concurrence must occur.  Please contact your State administering agency regarding this requirement. Additional information can be found on the [National Oceanic and Atmospheric Administration Office of Coastal Management website](https://coast.noaa.gov/czm/mystate/).  
      The State administering agency will have a six-month review period to provide a determination on your proposed project once all data and information required for review is received. The proposed work cannot be authorized by NWP if the State administering agency determines the work is not consistent with the requirements of the CZMA.`,
    questionTypeId: 99,
    parentQuestions: [getParentObject(170, 7, '=', 'NO')],
    endConditions: [],
    alertType: 'warning',
    ...commonQuestionData,
  },
  170.2: {
    sectionId: 61,
    helpInfo: 'General Condition 26.',
    question: 'Does the project comply with the conditions of the CZMA Federal Consistency Concurrence?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(170, 7, '=', 'YES')],
    ...commonQuestionData,
  },
  170.3: {
    sectionId: 61,
    question: `Your project requires an individual Coastal Zone Management Act (CZMA) consistency concurrence from the State administering agency  or a presumption of concurrence must occur.  Please contact your State administering agency regarding this requirement. Additional information can be found on the [National Oceanic and Atmospheric Administration Office of Coastal Management website](https://coast.noaa.gov/czm/mystate/).  
      The State administering agency will have a six-month review period to provide a determination on your proposed project once all data and information required for review is received. The proposed work cannot be authorized by NWP if the State administering agency determines the work is not consistent with the requirements of the CZMA.`,
    questionTypeId: 99,
    parentQuestions: [getParentObject(170.2, 5, '=', 'NO')],
    endConditions: [],
    alertType: 'warning',
    ...commonQuestionData,
  },
};
const multipleNwpUseQuestionsById: QuestionDataById = {
  171: {
    sectionId: 62,
    helpInfo: 'General Condition 28.',
    question: 'Will multiple NWPs be used to authorize a single and complete project?',
    questionTypeId: 5,
    parentQuestions: [
      getParentObject(170.2, 5, 'exists', ''),
      getParentObject(168, 5, '=', 'NO'),
      getParentObject(169, 5, '=', 'YES'),
      getParentObject(170, 7, '=', 'NO'),
    ],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.NonPcnLetter} />,
      },
    ],
    ...commonQuestionData,
  },
  172: {
    sectionId: 62,
    helpInfo: 'General Condition 28.',
    question:
      'Do impacts associated with the total project fall below the acreage limit of the NWP with the highest specified acreage limit?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(171, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  173: {
    sectionId: 62,
    helpInfo: 'General Condition 28.',
    question: 'Do impacts associated with each particular NWP fall within the specified acreage limit of that NWP?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(172, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.PreApplication} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NonPcnSuggest result={PcnResultTypes.NonPcnLetter} />,
      },
    ],
    ...commonQuestionData,
  },
};

export const generalQuestionsById = {
  ...navigationQuestionsById,
  ...aquaticLifeMovementQuestionsById,
  ...spawningAreaQuestionsById,
  ...migratoryBirdQuestionsById,
  ...shellfishBedsQuestionsById,
  ...suitableMaterialQuestionsById,
  ...waterSupplyQuestionsById,
  ...adverseImpoundmentQuestionsById,
  ...waterFlowManagementQuestionsById,
  ...floodplainQuestionsById,
  ...equipmentQuestionsById,
  ...soilErosionQuestionsById,
  ...removalOfTempStructuresFillsQuestionsById,
  ...properMaintenanceQuestionsById,
  ...singleCompleteProjectQuestionsById,
  ...tribalRightsQuestionsById,
  ...migratoryBirdGoldEagleQuestionsById,
  ...remainsArtifactsDiscoveryQuestionsById,
  ...critResourceWatersQuestionsById,
  ...mitigationQuestionsById,
  ...impoundmentStructureSafetyQuestionsById,
  ...waterQualityQuestionsById,
  ...coastalZoneManagementQuestionsById,
  ...multipleNwpUseQuestionsById,
};

export const generalConditionQuestions = {
  navigationQuestions: [navigationQuestionsById[133]],
  aquaticLifeMovementQuestions: [aquaticLifeMovementQuestionsById[134], aquaticLifeMovementQuestionsById[135]],
  spawningAreaQuestions: [spawningAreaQuestionsById[136]],
  migratoryBirdQuestions: [migratoryBirdQuestionsById[137]],
  shellfishBedQuestions: [shellfishBedsQuestionsById[138], shellfishBedsQuestionsById[139]],
  suitableMaterialQuestions: [suitableMaterialQuestionsById[140]],
  waterSupplyQuestions: [waterSupplyQuestionsById[141], waterSupplyQuestionsById[142]],
  adverseImpoundmentQuestions: [adverseImpoundmentQuestionsById[143]],
  waterFlowManagementQuestions: [
    waterFlowManagementQuestionsById[144],
    waterFlowManagementQuestionsById[145],
    waterFlowManagementQuestionsById[146],
  ],
  floodplainQuestions: [floodplainQuestionsById[147]],
  equipmentQuestions: [equipmentQuestionsById[148]],
  soilErosionQuestions: [soilErosionQuestionsById[149], soilErosionQuestionsById[150]],
  removalOfTempStructuresFillsQuestions: [removalOfTempStructuresFillsQuestionsById[151]],
  properMaintenanceQuestions: [properMaintenanceQuestionsById[152]],
  singleCompleteProjectQuestions: [
    singleCompleteProjectQuestionsById[153],
    singleCompleteProjectQuestionsById[154],
    singleCompleteProjectQuestionsById[155],
    singleCompleteProjectQuestionsById[156],
    singleCompleteProjectQuestionsById[157],
  ],
  tribalRightsQuestions: [tribalRightsQuestionsById[158]],
  migratoryBirdGoldEagleQuestions: [migratoryBirdGoldEagleQuestionsById[159]],
  remainsArtifactsDiscoveryQuestions: [remainsArtifactsDiscoveryQuestionsById[160]],
  critResourceWatersQuestions: [
    critResourceWatersQuestionsById[161],
    critResourceWatersQuestionsById[162],
    critResourceWatersQuestionsById[163],
  ],
  mitigationQuestions: [mitigationQuestionsById[164]],
  impoundmentStructureSafetyQuestions: [impoundmentStructureSafetyQuestionsById[165]],
  waterQualityQuestions: [
    waterQualityQuestionsById[166],
    waterQualityQuestionsById[166.1],
    waterQualityQuestionsById[167],
    waterQualityQuestionsById[167.1],
    waterQualityQuestionsById[168],
    waterQualityQuestionsById[169],
    waterQualityQuestionsById[169.1],
  ],
  coastalZoneManagementQuestions: [
    coastalZoneManagementQuestionsById[170],
    coastalZoneManagementQuestionsById[170.1],
    coastalZoneManagementQuestionsById[170.2],
    coastalZoneManagementQuestionsById[170.3],
  ],
  multipleNwpUseQuestions: [
    multipleNwpUseQuestionsById[171],
    multipleNwpUseQuestionsById[172],
    multipleNwpUseQuestionsById[173],
  ],
};
